/**
 * Local state vocabulary for the PDP location widget.
 *
 * `fixed`  → "Ik ga naar de aanbieder" (the customer travels to the partner;
 *            we rank partners by distance from the customer's city).
 * `custom` → "Aanbieder komt naar mij" (the partner travels to the customer;
 *            we estimate transport cost + draw a route). Maps to the map's
 *            partner-to-us route behaviour.
 */
export type WidgetMode = 'fixed' | 'custom';

/**
 * Anchor of the "Waar wil je deze activiteit doen?" heading. Partner links carry it as a
 * hash so opening another partner's activity lands on the widget instead of the page top.
 */
export const LOCATION_SECTION_ANCHOR_ID = 'regions';

export type WidgetLocation = {
    /** Human-readable label of the picked place (city name). */
    query: string;
    lat: number;
    lng: number;
    /** Closest region id, when resolved. */
    regionId?: number | null;
};
